export enum LaneType {
  None = 'None',
  ParkingFar = 'ParkingFar',
  DrivingFar = 'DrivingFar',
  DrivingCenter = 'DrivingCenter',
  DrivingNear = 'DrivingNear',
  ParkingNear = 'ParkingNear',
}

export const LANE_TYPES: Array<{ id: LaneType; name: string; color: string }> = [
  { id: LaneType.ParkingFar, name: 'PARKING FAR (Green)', color: 'green' },
  { id: LaneType.DrivingFar, name: 'DRIVING FAR (Blue)', color: 'blue' },
  { id: LaneType.DrivingCenter, name: 'DRIVING CENTER (White)', color: 'white' },
  { id: LaneType.DrivingNear, name: 'DRIVING NEAR (Red)', color: 'red' },
  { id: LaneType.ParkingNear, name: 'PARKING NEAR (Yellow)', color: 'yellow' },
];
